import React from 'react'
import ReactDOM from 'react-dom'
import { IntlProvider } from 'react-intl'
import {
    MuiThemeProvider,
    createTheme,
    StylesProvider,
} from '@material-ui/core/styles'

import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import FirebaseManager from './fronted-share-components/src/utils/firebaseManager.js'
import EventManager from './util/eventManager'
import { RouterProvider } from './contexts/routerContext.js'
import getSupportedLang from './fronted-share-components/src/utils/getSupportedLang.js'
import setEnv from './fronted-share-components/src/setEnv'
import LogManager from './fronted-share-components/src/LogManager'
import AmplitudeManager from './fronted-share-components/src/utils/amplitudeManager.js'
import AmplitudeEventManager from './fronted-share-components/src/utils/amplitudeEventManager'
import { buildNumber, version } from './constants/buildNumber.json'

import en from './locales/en'
import zh from './locales/zh'
import ja from './locales/ja'
import ko from './locales/ko'
import es from './locales/es'
import pt from './locales/pt'

const { env, alfredTest2wsxsw2 } = setEnv(window.location.origin)
window.env = env
window.alfredTest2wsxsw2 = alfredTest2wsxsw2

window.logManager = LogManager.getInstance()

FirebaseManager.getInstance({
    FCM_API_KEY: 'AIzaSyCZnFc7Ea4BLfGTa044z3oYkuSD5UF2KuE',
    FCM_AUTH_DOMAIN: 'api-project-317780763450.firebaseapp.com',
    FCM_DATABASE_URL: 'https://api-project-317780763450.firebaseio.com',
    FCM_PROJECT_ID: 'api-project-317780763450',
    FCM_STORAGE_BUCKET: 'api-project-317780763450.appspot.com',
    FCM_MESSAGING_SENDER_ID: '317780763450',
    FCM_APP_ID: '1:317780763450:web:be60c3cf7662af679e6603',
    FCM_MESUREMENT_ID: 'G-XWYHJRQYMY',
    // reCAPTCHA Enterprise key shared with the Web Viewer (public value)
    RECAPTCHA_SITE_KEY: '6Lf8S2ktAAAAAOej_bhcQfDVbHS_YeYhVwOzn6pM',
    APP_CHECK_DEBUG: window.env === 'local',
})

AmplitudeManager.init({
    amplitudeApiKey: 'f63d74089ecefef085a8b95e757e695e',
    appVersion: `${version}.${buildNumber}`,
})
AmplitudeEventManager.setDefaultEventProperties({
    appVersion: `${version}.${buildNumber}`,
    mode: 'camera',
})

window.eventManager = new EventManager()

const theme = createTheme({
    palette: {
        primary: {
            light: '#fcc35d',
            main: '#fcc35d',
            dark: '#fcc35d',
            contrastText: '#000',
        },
        secondary: {
            light: '#FD9728',
            main: '#FD9728',
            dark: '#FD9728',
            contrastText: '#fff',
        },
    },
})
const userLanguage = getSupportedLang()

const messages = {
    en,
    zh,
    ja,
    ko,
    es,
    pt,
}

// override console log on production
if (window.alfredTest2wsxsw2 === false) {
    window.console = new Proxy(window.console, {
        get: function (target, prop, receiver) {
            // disable log except error log
            if (prop !== 'error') {
                return function () {}
            }
            return Reflect.get(target, prop, receiver)
        },
    })
}

ReactDOM.render(
    <StylesProvider injectFirst={true}>
        <MuiThemeProvider theme={theme}>
            <IntlProvider
                locale={userLanguage}
                messages={messages[userLanguage]}
            >
                <RouterProvider>
                    <App />
                </RouterProvider>
            </IntlProvider>
        </MuiThemeProvider>
    </StylesProvider>,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
